import { mapEntityProperties } from '@/utils/mapEntityProperties'
import type { OrderCancellationPolicyActionLogAdminDto } from '@/backend/market'
import { OrderCancellationPolicyHistoryEntity } from '../../domain/entities/OrderCancellationPolicyHistoryEntity'

export class OrderCancellationPolicyHistoryModel extends OrderCancellationPolicyHistoryEntity {
  constructor(dataDto: OrderCancellationPolicyActionLogAdminDto) {
    super()
    mapEntityProperties<OrderCancellationPolicyHistoryEntity>(this, dataDto)
  }
}
